/**
 * File add-to-calendar.js.
 *
 * Add To Calendar dropdown and dynamic creation.
 *
 * @package wildrivers
 */
import { WPAjax } from './wpajax';

export function addToCalendar() {
	const calendars = document.querySelectorAll( '.add-to-calendar-links' );
	if ( ! calendars?.length ) {
		return;
	}

	calendars.forEach( ( calendar ) => {
		const toggleButton = calendar.querySelector( 'button' );
		const menu = calendar.querySelector( '.share-links-expander' );
		const icsLinks = calendar.querySelectorAll( 'a.add-to-calendar-download[data-id]' );

		if ( toggleButton && menu ) {
			toggleButton.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				calendar.classList.toggle( 'share-links--active' );
				const expanded = calendar.classList.contains( 'share-links--active' );
				toggleButton.setAttribute( 'aria-expanded', expanded ? 'true' : 'false' );
				menu.setAttribute( 'aria-expanded', expanded ? 'true' : 'false' );
			} );
		}

		icsLinks?.forEach( ( link ) => {
			link.addEventListener( 'click', async ( e ) => {
				e.preventDefault();

				const eventId = link.dataset.id;
				const name = link.dataset.name || 'event';
				if ( ! eventId ) return;

				try {
					const data = await WPAjax( 'wr_add_to_calendar_ajax', { id: eventId } );
					const blob = new Blob( [ data ], { type: 'text/calendar' } );
					const url = window.URL.createObjectURL( blob );
					const a = document.createElement( 'a' );
					a.href = url;
					a.download = `${ name }.ics`;
					document.body.appendChild( a );
					a.click();
					window.URL.revokeObjectURL( url );
					document.body.removeChild( a );
				} catch ( err ) {
					// eslint-disable-next-line no-console
					console.error( err );
				}
			} );
		} );

		// Close when clicking outside.
		document.addEventListener( 'click', ( e ) => {
			if ( ! calendar.classList.contains( 'share-links--active' ) ) return;
			if ( calendar.contains( e.target ) ) return;
			calendar.classList.remove( 'share-links--active' );
			toggleButton?.setAttribute( 'aria-expanded', 'false' );
			menu?.setAttribute( 'aria-expanded', 'false' );
		} );
	} );
}
